module.exports = __webpack_public_path__ + "img/cat_v2.4569a271.gif";